import { Injectable, OnDestroy } from '@angular/core';
import { AjaxService } from '.././services/ajax.service';
import { availablePaymentMethodsMap, availableWithdrawMethodsMap } from '../shared/utility/config';
import { Subject } from 'rxjs';
import { Utility } from '../shared/utility/utility';
import {EmitterService} from '../services/emitter.service';
import { Router } from '@angular/router';
import { UserDetailsService } from '../services/user-details.service';
import { takeUntil } from "rxjs/operators";

import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import * as _ from 'underscore';

@Injectable()
export class PaymentService implements OnDestroy {
  available_payment_methods_limitsQueue = [];
  cashierDetails_callsQueue = [];
  private errorMessage = new Subject<string>();
  errorMessage$ = this.errorMessage.asObservable();
  private formSubmitted = new Subject<string>();
  formSubmitted$ = this.formSubmitted.asObservable();
  preURL;
  depositCCAvailable: boolean;
  langCode;
  bannerId;
  userDetails;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private ajaxService: AjaxService,
    private utils: Utility,
    private emitterService: EmitterService,
    private router: Router,
    private userDetailsService: UserDetailsService
  ) {
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });
  }

  ClearQueue() {
    this.cashierDetails_callsQueue = [];
    this.available_payment_methods_limitsQueue = [];
  }

  getAvailablePaymentMethodsLimits(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.available_payment_methods_limitsQueue.length > 0) {
        this.available_payment_methods_limitsQueue.push(resolve);
      } else {
        this.available_payment_methods_limitsQueue.push(resolve);
        this.ajaxService.getAvailablePaymentMethodLimits()
          .then(availableLimitData => {
            let resp_data = {};
            if (availableLimitData) {
              resp_data = {
                cashierDepositLimitList: availableLimitData['cashierDepositLimitList'],
                cashierCashoutLimitList: availableLimitData['cashierCashoutLimitList']
              };
            }

            for (; this.available_payment_methods_limitsQueue.length > 0;) {
              this.available_payment_methods_limitsQueue[0](resp_data);
              this.available_payment_methods_limitsQueue.splice(0, 1);
            }

          });
      }
    });
  }
  getCashierDetails(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.cashierDetails_callsQueue.length > 0) {
        this.cashierDetails_callsQueue.push(resolve);
      } else {
        this.cashierDetails_callsQueue.push(resolve);
        this.ajaxService.getCashierData()
          .then(data => {
            for (; this.cashierDetails_callsQueue.length > 0;) {
              let resp_obj = data ? JSON.parse(JSON.stringify(data)) : {};
              this.cashierDetails_callsQueue[0](resp_obj);
              this.cashierDetails_callsQueue.splice(0, 1);
            }

          });
      }

    });
  }
  getAvailableLimits(LimitList, type, currency) {
    let LimitListTemp = {};
    if (type === "deposit") {
      _.each(LimitList, function (limits) {
        if (limits.currency === currency) {
          if (!LimitListTemp[limits.option]) {
            LimitListTemp[limits.option] = {};
          }
          LimitListTemp[limits.option]["minTxnLimit"] = limits.minTxnLimit;
          LimitListTemp[limits.option]["maxTxnLimit"] = limits.maxTxnLimit;
          LimitListTemp[limits.option]["feeType"] = limits.feeType;
          LimitListTemp[limits.option]["feeAmount"] = limits.feeAmount;
          LimitListTemp[limits.option]["maxFeeAmount"] = limits.maxFeeAmount;
          LimitListTemp[limits.option]["minFeeAmount"] = limits.minFeeAmount;
        }
      });
    } else {
      _.each(LimitList, function (limits) {
        if (limits.currency === currency) {
          if (!LimitListTemp[limits.option]) {
            LimitListTemp[limits.option] = {};
          }
          LimitListTemp[limits.option]["minTxnLimit"] = limits.minTxnLimit;
          LimitListTemp[limits.option]["maxTxnLimit"] = limits.maxTxnLimit;
          LimitListTemp[limits.option]["feeType"] = limits.feeType;
          LimitListTemp[limits.option]["maxFeeAmount"] = limits.maxFeeAmount;
          LimitListTemp[limits.option]["minFeeAmount"] = limits.minFeeAmount;
          LimitListTemp[limits.option]["feeAmount"] = limits.feeAmount;
        }
      });
    }
    return this.getLimitMap(LimitListTemp, type);
  }

  getLimitMap(LimitListTemp, type) {
    let LimitList = {};
    let availableMethodsMap;
    type === "deposit" ? availableMethodsMap = availablePaymentMethodsMap : availableMethodsMap = availableWithdrawMethodsMap;
    _.each(availableMethodsMap, function (paymentType, key) {
      if (typeof paymentType === "object") {
        let keyToPut = key;
        _.each(paymentType, function (paymentTypeInside, key) {
          if (!LimitList[keyToPut] && LimitListTemp[paymentTypeInside.methodName]) {
            LimitList[keyToPut] = {
              "minTxnLimit": LimitListTemp[paymentTypeInside.methodName].minTxnLimit,
              "maxTxnLimit": LimitListTemp[paymentTypeInside.methodName].maxTxnLimit,
              "feeType": LimitListTemp[paymentTypeInside.methodName].feeType,
              "maxFeeAmount": LimitListTemp[paymentTypeInside.methodName].maxFeeAmount,
              "minFeeAmount": LimitListTemp[paymentTypeInside.methodName].minFeeAmount,
              "feeAmount": LimitListTemp[paymentTypeInside.methodName].feeAmount,

            };
          } else if (LimitListTemp[paymentTypeInside.methodName]) {
            LimitList[keyToPut] = {
              "minTxnLimit": LimitList[keyToPut].minTxnLimit > LimitListTemp[paymentTypeInside.methodName].minTxnLimit ?
                LimitListTemp[paymentTypeInside.methodName].minTxnLimit : LimitList[keyToPut].minTxnLimit,
              "maxTxnLimit": LimitList[keyToPut].maxTxnLimit < LimitListTemp[paymentTypeInside.methodName].maxTxnLimit ?
                LimitListTemp[paymentTypeInside.methodName].maxTxnLimit : LimitList[keyToPut].maxTxnLimit,
              "feeType": LimitListTemp[paymentTypeInside.methodName].feeType,
              "maxFeeAmount": LimitListTemp[paymentTypeInside.methodName].maxFeeAmount,
              "minFeeAmount": LimitListTemp[paymentTypeInside.methodName].minFeeAmount,
              "feeAmount": LimitListTemp[paymentTypeInside.methodName].feeAmount
            };
          }
        });
      } else {
        if (!LimitList[key] && LimitListTemp[key]) {
          LimitList[key] = {
            "minTxnLimit": LimitListTemp[key].minTxnLimit,
            "maxTxnLimit": LimitListTemp[key].maxTxnLimit,
            "feeType": LimitListTemp[key].feeType,
            "maxFeeAmount": LimitListTemp[key].maxFeeAmount,
            "minFeeAmount": LimitListTemp[key].minFeeAmount,
            "feeAmount": LimitListTemp[key].feeAmount
          };
        } else if (LimitListTemp[key]) {
          LimitList[key] = {
            "minTxnLimit": LimitList[key].minTxnLimit > LimitListTemp[key].minTxnLimit ?
              LimitListTemp[key].minTxnLimit : LimitList[key].minTxnLimit,
            "maxTxnLimit": LimitList[key].maxTxnLimit < LimitListTemp[key].maxTxnLimit ?
              LimitListTemp[key].maxTxnLimit : LimitList[key].maxTxnLimit,
            "feeType": LimitListTemp[key].feeType,
            "maxFeeAmount": LimitListTemp[key].maxFeeAmount,
            "minFeeAmount": LimitListTemp[key].minFeeAmount,
            "feeAmount": LimitListTemp[key].feeAmount,
          };
        }
      }
    });

    return LimitList;
  }

  setError(errorMsg, buttonId, errorDiv, oldMessage) {
    if (errorDiv) {
      this.errorMessage.next(errorMsg);
      this.utils.showError(errorDiv);
      if ($(errorDiv).length > 0) {
        $(errorDiv).html(errorMsg);
      }
    }
    if (buttonId) {
      let text = oldMessage ? oldMessage : "DEPOSIT";
      this.utils.enableNewButton(buttonId, errorDiv ? "FAILED" : "SUCCESS", errorDiv ? "Please Try Again" : "SUCCESS", text);
      this.formSubmitted.next("false");
    }
  }
  afterPaymentSuccessfull(payementResponse, lotteryDetails, buttonId, errorDiv, retryCount): void {
    Promise.resolve(this.ajaxService.getTransactionStatus({ "txnId": payementResponse.txnId }))
      .then(payementStatus => {
        $(".mobile_modal_closeicon, .icon-cancel-svg").removeClass('hide');
        if (payementStatus && payementStatus["status"] === "SUCCESS" && payementStatus["actualStatusInDB"] === "txn_confirmed_success") {
          // this.emitterService.broadcastPurchaseLoaderEvent(35);
          if (payementStatus["txnType"] === "deposit") {
            this.redirectToTranscationSuccessful(payementResponse, payementStatus, "SUCCESS");
          } else if (payementStatus["txnType"] === "deposit-cashier") {
            this.redirectToTranscationSuccessful(payementResponse, payementStatus, "SUCCESS");
          }
        } else if (payementStatus && payementStatus["actualStatusInDB"] === "txn_initiated") {

          if (retryCount > 4) {
            this.redirectToTranscationSuccessful(payementResponse, "", "FAILURE");
          } else {
            retryCount++;
            this.afterPaymentSuccessfull(payementResponse, lotteryDetails, buttonId, errorDiv, retryCount);

          }

        } else if (payementStatus && payementStatus["status"] === "FAILURE" && payementStatus["actualStatusInDB"] === "txn_confirmed_failure") {
          this.redirectToTranscationSuccessful(payementResponse, payementStatus, "FAILURE");
        } else if (payementStatus && payementStatus["status"] === "FAILURE") {
          this.redirectToTranscationSuccessful(payementResponse, payementStatus, "FAILURE");
        } else {
          this.redirectToTranscationSuccessful(payementResponse, "", "FAILURE");
        }

      },
        SystemError => {
          this.emitterService.broadcastCanclePurchaseLoaderEvent(true);
          this.setError("Something Went wrong Please try again Later", buttonId, errorDiv, undefined);
        });
  }
  redirectToTranscationSuccessful(payementResponse, payementStatus, status): void {
    //this.emitterService.broadcasttxnComplete("SUCCESS");
    let txnDetails;
    if (payementResponse && payementStatus) {
      if (this.userDetailsService.getUserProfileDetails() && this.userDetailsService.getUserProfileDetails().userStatus === 'play') {
        this.utils.gtmEvent("userFirstDeposit", {
          txnId: payementStatus.txnId,
          userExternalECR: this.userDetailsService.getUserProfileDetails().playerID
        });
        if(payementResponse["depositAmount"] > 20 && this.userDetails && this.userDetails["affiliateLinkID"] === '460' && this.userDetails["bannerID"]) {
          $("body").append('<img src="https://templive.spudo.com/s2s?cpa='+ this.userDetails["bannerID"] +'" alt=" " title=" " width="0" height="0"/>');
        }
      } else {
        this.utils.gtmEvent("userDeposited", {
          txnId: payementStatus.txnId,
          userExternalECR: this.userDetailsService.getUserProfileDetails().playerID
        });
      }

      txnDetails = this.utils.gettransactionSuccessfullDeatils(
        payementStatus.txnId, payementResponse.depositAmount ? payementResponse.depositAmount : payementStatus.transactionAmount,
        payementResponse.AccountId, payementStatus.paymentMethod, payementStatus.cardNumber, payementStatus.txnType);
      txnDetails["failiureReason"] = payementStatus.errorDescription;
    } else {
      txnDetails = this.utils.gettransactionSuccessfullDeatils("", "", "", "", "", "");
    }

    txnDetails["transactionStatus"] = status;
    this.router.navigate([this.langCode + '/txn-confirmation'], { queryParams: txnDetails });
  }
  paymentPendingFor3dVerification(payementResponse, paymentMethod) {
    switch (paymentMethod) {
      case "VISA_HOSTED":
      case "CREDITCARD":
        if ((undefined != payementResponse["redirectURL"]) && (payementResponse["redirectURL"].length > 0)) {
          this.emitterService.broadcastPurchaseLoaderEvent(50);
          let $iframe = $('<div class="depositLoadingIframe"><div class="loader loader-large"></div><iframe name="cciFrame" id="loaderIframe" class="showIframe" ng-init="init()" src="" style="width: 100%;height: 450px;margin: auto;margin-top: -22px; display: block;border: 0;"></iframe>');
          let $form;
          if (payementResponse["redirectParamsList"]) {
            $form = $('<form id="proxy_redirect" method="POST" action="' + payementResponse["redirectURL"] + '"></form>');
            _.forEach(payementResponse["redirectParamsList"], function (value, key) {
              if (value) {
                if (key === 'field_3' && parseInt(value) < 10 && !value.includes("0")) {
                  value = parseInt(value);
                  if (value < 10) value = "0" + value;
                }
                $form.append('<input type="hidden" name="' + key + '" value="' + value + '" />');
              }
            });
          } else if (payementResponse['gatewayRequest'] && payementResponse["gatewayRequest"]['params']) {
            $form = $('<form id="proxy_redirect" method="POST" action="' + payementResponse["redirectURL"] + '"></form>');
            $form.append('<input type="hidden" name="params" value="' + payementResponse["gatewayRequest"]['params'] + '" />');
          } else {
            payementResponse["redirectURL"] = payementResponse["redirectURL"].replace('document.forms[0].submit();', '');
            $form = $(payementResponse["redirectURL"]);
            $form.addClass("hide");
          }
          if ($("#quickDepositModal").length > 0) {
            this.utils.closeModal("quickDepositModal");
            this.utils.openModal("Modal3D");
            $("#card-redirect-container").append($form);
            $("#card-redirect-container").append($iframe);
            $("#proxy_redirect").attr('target', 'cciFrame');
          } else {
            $("#card-redirect-container").append($iframe);
            $("#card-redirect-container").append($form);
            $("#proxy_redirect").attr('target', 'cciFrame');
          }
          $("#proxy_redirect").submit();
        }
        break;
      case "NETELLER":
      case "SKRILL":
      case "ZIMPLER":
      case "TRUSTLY":

        let $iframe = $('<iframe name="cciFrame" id="loaderIframe" class="showIframe" ng-init="init()" src="' + payementResponse.redirectURL + '" style="width: 100%;height: 650px;margin: auto;display: block;border: 0;"></iframe>');
        $("#card-redirect-container").append($iframe);
        $("#proxy_redirect").attr('target', 'cciFrame');
        if(paymentMethod === "TRUSTLY") {
          this.utils.trustlyIframeGTMevent("loaderIframe");
        }
        break;
      case "SOFORT":
      case "IDEAL":
      case "RAPID_TRANSFER":
      window.open(payementResponse.redirectURL ,'_self');
    }
  }
  setPrevURL(url): any {
    this.preURL = url;
  }

  getPrevURL() {
    if (!this.preURL) {
      return '/myaccount/cashier';
    }
    return this.preURL;
  }
  afterCashoutSuccessfull(payementResponse, gameDetails, buttonId, errorDiv, retryCount): void {
    let txnDetails;
    Promise.resolve(this.ajaxService.getTransactionStatus({ "txnId": payementResponse.txnId, "type": payementResponse["paymentType"] })).then(payementStatus => {
        if (payementStatus && payementStatus["status"] === "SUCCESS" && payementStatus["actualStatusInDB"] === "co_initiated") {
          this.redirectToCashoutTranscation(payementResponse, payementStatus, "PENDING", false);
        } else if (payementStatus && payementStatus["status"] === "SUCCESS" && payementStatus["actualStatusInDB"] === "co_success") {
          this.redirectToCashoutTranscation(payementResponse, payementStatus, "SUCCESS", false);
        } else if (payementStatus && payementStatus["status"] === "FAILURE" && payementStatus["actualStatusInDB"] === "co_failed") {
          this.redirectToCashoutTranscation(payementResponse, payementStatus, "FAILURE", false);
        } else {
          this.redirectToCashoutTranscation(payementResponse, payementStatus, "FAILURE", false);
        }
      });
  }
  redirectToCashoutTranscation(payementResponse, payementStatus, status, isTimeout): void {
    this.emitterService.broadcasttxnComplete("SUCCESS");
    let txnDetails;
    if (payementResponse && payementStatus && !isTimeout) {
      txnDetails = {
        ["txnId"]: payementResponse.txnId,
        ["amount"]: payementResponse.depositAmount,
        txnDate: new Date(),
        paymentType: "Cashout"
      };
      txnDetails["failiureReason"] = payementStatus.errorDescription;
    } else {
      txnDetails = this.utils.gettransactionSuccessfullDeatils("", "", "", "", "", "");
    }

    txnDetails["transactionStatus"] = status;
    if (txnDetails["transactionStatus"] === "FAILURE") {
      this.router.navigate([this.langCode + '/failure', "Failed to withdraw. "]);
    } else {
      this.router.navigate([this.langCode + '/success']);
    }
  }
  getDepositCCAvailable() {
    return this.depositCCAvailable;
  }
  setDepositCCAvailable(depositCCAvailable: boolean) {
    this.depositCCAvailable = depositCCAvailable;
  }
  getPNPDepositFee(payLoad) {
    return this.ajaxService.getPNPDepositFee(payLoad);
  }
  getPNPMinMaxTxnLimits(payLoad) {
    return this.ajaxService.getPNPMinMaxTxnLimits(payLoad);
  }
  getuserDetails(userDetails) {
    return this.userDetails;
  }
  setuserDetails(userDetails) {
    this.userDetails = userDetails;
  }
  depositeProcess(data){
    return this.ajaxService.depositeProcess(data);
  }
  getPaymentMethod(){
    return this.ajaxService.getCahsierConfiguareationMethod();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
